import PropTypes from "prop-types"
import React, { useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Form,
  Alert,
  FormFeedback,
  Label,
} from "reactstrap"

import { useNavigate } from "react-router-dom"

import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"

import { post } from "helpers/api_helper"

import * as Yup from "yup"
import { useFormik } from "formik"

const LineSettingCreate = props => {
  const navigate = useNavigate()
  const [submitLoading, setSubmitLoading] = useState(false)
  const [successMsg, setSuccessMsg] = useState("")
  const [errorMsg, setErrorMsg] = useState("")

  document.title = "Add New Account | " + process.env.REACT_APP_CMS_TITLE

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      oa_name: "",
      channel_id: "",
      channel_secret: "",
      channel_access_token: "",
      channel_id_login: "",
      channel_secret_login: "",
      basic_id: "",
      picture_url: "",
      active: true,
    },
    validationSchema: Yup.object({
      oa_name: Yup.string().required("Please Enter Account Name"),
      channel_id: Yup.string().required("Please Enter Channel ID"),
      channel_secret: Yup.string().required("Please Enter Channel Secret"),
      channel_access_token: Yup.string().required("Please Enter Channel Access Token"),
      channel_id_login: Yup.string().required("Please Enter Channel ID Login"),
      channel_secret_login: Yup.string().required("Please Enter Channel Secret Login"),
      basic_id: Yup.string(),
      picture_url: Yup.string(),
      active: Yup.boolean(),
    }),
    onSubmit: async values => {
      setSubmitLoading(true)
      setErrorMsg("")
      try {
        await post(
          process.env.REACT_APP_BACKEND_URL + "/v1/admin/line-oa",
          values
        )
        setSuccessMsg("Create Account Successfully")
        setTimeout(() => navigate("/systemsettings/linesetting"), 1500)
      } catch (err) {
        setErrorMsg(err?.response?.data?.message || "Create failed")
      } finally {
        setSubmitLoading(false)
      }
    },
  })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Add New Account")}
            breadcrumbItems={[
              {
                title: props.t("System Setting"),
                link: props.t("systemsettings"),
              },
              {
                title: props.t("Line Account Setting"),
                link: props.t("linesetting"),
              },
              {
                title: props.t("Add New Account"),
                link: props.t("create"),
              },
            ]}
          />

          <div className="bInnerContent">
            <Row>
              <Col className="col-12">
                <Form
                  className="form-horizontal"
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                >
                  {successMsg && (
                    <Alert color="success">{successMsg}</Alert>
                  )}
                  {errorMsg && (
                    <Alert color="danger">{errorMsg}</Alert>
                  )}

                  <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: "#E6F8F3",
                        color: "#1a5d3a",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Add New Account
                    </div>
                    <CardBody>
                      <Row>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="oa_name">
                              Account Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="oa_name"
                              name="oa_name"
                              className="form-control"
                              placeholder="Enter Account Name"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.oa_name || ""}
                              invalid={
                                validation.touched.oa_name &&
                                validation.errors.oa_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.oa_name &&
                            validation.errors.oa_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.oa_name}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="channel_id">
                              Channel ID <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="channel_id"
                              name="channel_id"
                              className="form-control"
                              placeholder="Enter Channel ID"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.channel_id || ""}
                              invalid={
                                validation.touched.channel_id &&
                                validation.errors.channel_id
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.channel_id &&
                            validation.errors.channel_id ? (
                              <FormFeedback type="invalid">
                                {validation.errors.channel_id}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="channel_secret">
                              Channel Secret <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="channel_secret"
                              name="channel_secret"
                              className="form-control"
                              placeholder="Enter Channel Secret"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.channel_secret || ""}
                              invalid={
                                validation.touched.channel_secret &&
                                validation.errors.channel_secret
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.channel_secret &&
                            validation.errors.channel_secret ? (
                              <FormFeedback type="invalid">
                                {validation.errors.channel_secret}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="channel_access_token">
                              Channel Access Token <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="channel_access_token"
                              name="channel_access_token"
                              className="form-control"
                              placeholder="Enter Channel Access Token"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.channel_access_token || ""}
                              invalid={
                                validation.touched.channel_access_token &&
                                validation.errors.channel_access_token
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.channel_access_token &&
                            validation.errors.channel_access_token ? (
                              <FormFeedback type="invalid">
                                {validation.errors.channel_access_token}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="basic_id">
                              Basic ID
                            </Label>
                            <Input
                              id="basic_id"
                              name="basic_id"
                              className="form-control"
                              placeholder="Enter Basic ID (e.g. @abc-shop)"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.basic_id || ""}
                            />
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="picture_url">
                              Picture URL
                            </Label>
                            <Input
                              id="picture_url"
                              name="picture_url"
                              className="form-control"
                              placeholder="Enter Picture URL"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.picture_url || ""}
                            />
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: "#E6F8F3",
                        color: "#1a5d3a",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Line Login
                    </div>
                    <CardBody>
                      <Row>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="channel_id_login">
                              Channel ID Login <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="channel_id_login"
                              name="channel_id_login"
                              className="form-control"
                              placeholder="Enter Channel ID Login"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.channel_id_login || ""}
                              invalid={
                                validation.touched.channel_id_login &&
                                validation.errors.channel_id_login
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.channel_id_login &&
                            validation.errors.channel_id_login ? (
                              <FormFeedback type="invalid">
                                {validation.errors.channel_id_login}
                              </FormFeedback>
                            ) : null}
                          </div>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="channel_secret_login">
                              Channel Secret Login <span className="text-danger">*</span>
                            </Label>
                            <Input
                              id="channel_secret_login"
                              name="channel_secret_login"
                              className="form-control"
                              placeholder="Enter Channel Secret Login"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.channel_secret_login || ""}
                              invalid={
                                validation.touched.channel_secret_login &&
                                validation.errors.channel_secret_login
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.channel_secret_login &&
                            validation.errors.channel_secret_login ? (
                              <FormFeedback type="invalid">
                                {validation.errors.channel_secret_login}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <Card style={{ borderRadius: "8px", overflow: "hidden" }}>
                    <div
                      className="p-3"
                      style={{
                        backgroundColor: "#E6F8F3",
                        color: "#1a5d3a",
                        fontWeight: "600",
                        fontSize: "1.1rem",
                        borderTopLeftRadius: "8px",
                        borderTopRightRadius: "8px",
                      }}
                    >
                      Status
                    </div>
                    <CardBody>
                      <Row>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label className="form-label" htmlFor="active">
                              Status
                            </Label>
                            <Input
                              id="active"
                              name="active"
                              type="select"
                              className="form-control"
                              onChange={e =>
                                validation.setFieldValue(
                                  "active",
                                  e.target.value === "true"
                                )
                              }
                              onBlur={validation.handleBlur}
                              value={String(validation.values.active)}
                            >
                              <option value="true">Active</option>
                              <option value="false">Inactive</option>
                            </Input>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>

                  <div className="d-flex justify-content-between">
                    <Button
                      color="secondary"
                      outline
                      onClick={() => navigate("/systemsettings/linesetting")}
                    >
                      <i className="bx bx-x me-1"></i>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      color="success"
                      disabled={submitLoading}
                    >
                      <i className="bx bx-check me-1"></i>
                      {submitLoading ? "Submitting..." : "Confirmation"}
                    </Button>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

LineSettingCreate.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(LineSettingCreate)
